<template>
  <div v-if="user.authenticated" class="is-fullheight">
    <nav>
      <span id="header"><strong>Expeditr</strong></span>
      <br><span><strong>Version:</strong> {{ version.version }}</span>
      <ul>
        <br/>
        <li v-if="has_permissions(['read_orders'])"><router-link to="/order_status"><span class="icon"><i class="fa fa-check" aria-hidden="true"></i></span><span>Order Status</span></router-link></li>
        <hr/>
        <li v-if="has_permissions(['read_orders', 'write_orders'])"><router-link to="/sync_order"><span class="icon"><i class="fa fa-truck" aria-hidden="true"></i></span><span>Sync Order</span></router-link></li>
        <li v-if="has_permissions(['write_products', 'read_products'])"><router-link to="/sync_product"><span class="icon"><i class="fa fa-archive" aria-hidden="true"></i></span><span>Sync Product</span></router-link></li>
        <li v-if="has_permissions(['trigger_backups'])"><router-link to="/backup_tasks"><span class="icon"><i class="fa fa-refresh" aria-hidden="true"></i></span><span>Backup Tasks</span></router-link></li>
        <li v-if="has_permissions(['trigger_backups'])"><router-link to="/process_orders"><span class="icon"><i class="fa fa-refresh" aria-hidden="true"></i></span><span>Process Orders</span></router-link></li>
        <li v-if="has_permissions(['read_orders'])"><router-link to="/unsynced_orders"><span class="icon"><i class="fa fa-truck" aria-hidden="true"></i></span><span>Unsynced Order</span></router-link></li>
        <hr/>
        <li v-if="has_permissions(['config_sage'])"><router-link to="/sage_config"><span class="icon"><i class="fa fa-keyboard-o" aria-hidden="true"></i></span><span>Sage Configuration</span></router-link></li>
        <hr/>
        <li v-if="has_permissions(['config_webhooks'])"><router-link to="/webhooks"><span class="icon"><i class="fa fa-wrench" aria-hidden="true"></i></span><span>Manage Webhooks</span></router-link></li>
        <li v-if="has_permissions(['read_redis_queue'])"><router-link to="/redis_queue"><span class="icon"><i class="fa fa-wrench" aria-hidden="true"></i></span><span>Redis Queue</span></router-link></li>
        <br/>
        <li><router-link to="/logout"><span class="icon"><i class="fa fa-sign-out" aria-hidden="true"></i></span><span>Log out</span></router-link></li>
      </ul>
    </nav>
  </div>
</template>

<script>
import auth from '../auth'
export default {
  name: 'Navigation',
  data () {
    return {
      user: auth.user,
      version: auth.version
    }
  },
  methods: {
    has_permissions (permissions) {
      return permissions.every(auth.hasPermission, auth.getPermissions())
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
nav {
  margin: 0;
  padding: 10px;
  background-color: #f1f1f1;
  height: 100%;
  overflow: auto;
  text-align: left;
}

#header {
  font-family: Faster One,cursive;
  font-size: 16pt;
}
</style>
